import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    href: "",
    class: "category-selection__toggle"
};
const _hoisted_2 = { class: "category-selection__dropdown" };
import { ref, watch } from "vue";
import products from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import { useClickaway } from "@astina/paloma-common-ui/src/composables/clickaway";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogCategorySelection',
    props: {
        category: {}
    },
    setup(__props) {
        const props = __props;
        const categories = ref([]);
        const loaded = ref(false);
        const showDropdown = ref(false);
        const el = ref(null);
        useClickaway(el, hideDropdown);
        // this `watch` never happens because the caller re-renders everything,
        //   anyway. Leaving it in just because it was already here. Please change
        //   this comment if you've got more insight.
        watch(props, onCategoryChange);
        // init data
        products.listCategories()
            .then(responseCategories => {
            categories.value = responseCategories;
        })
            .finally(() => loaded.value = true);
        function onCategoryChange() {
            showDropdown.value = false;
        }
        function toggleDropdown() {
            showDropdown.value = !showDropdown.value;
        }
        function hideDropdown() {
            showDropdown.value = false;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            const _component_router_link = _resolveComponent("router-link");
            return (loaded.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["category-selection", { 'category-selection--open': showDropdown.value }]),
                    ref_key: "el",
                    ref: el
                }, [
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleDropdown())),
                        class: "category-selection__title"
                    }, [
                        _createElementVNode("h2", null, _toDisplayString(__props.category ? __props.category.name : _ctx.$t('catalog.all_categories')), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (categories.value.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                _createVNode(_component_icon, {
                                    name: showDropdown.value ? 'angle-up' : 'angle-down'
                                }, null, 8, ["name"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_2, [
                        (__props.category)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'catalog_category' },
                                class: "category-selection__dropdown-item category-selection__dropdown-item--all"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('catalog.all_categories')), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                                key: cat.code,
                                to: { name: 'catalog_category', params: { category: cat.code } },
                                class: "category-selection__dropdown-item"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cat.name), 1)
                                ]),
                                _: 2
                            }, 1032, ["to"]));
                        }), 128))
                    ])
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
